<app-spinner [loading]="spinnerService.loading$ | async" id="spinner" />
<app-header-bar
  [showButton]="false"
  [showDate]="true"
  [title]="_welcomeMessage | translate"
  id="header"
/>
<div class="bigger-container">
  <div class="dashboard-container">
    <app-primary-card size="small">
      <div class="dashboard-client-card">
        <app-client-search [pageMode]="_pageMode" />
        <div class="dashboard-title-container">
          <div class="mat-headline-2" id="title">
            {{ _pageTitle | translate }}
            <app-tooltip
              class="tooltip"
              height="14"
              id="tooltip"
              left="28"
              top="-8"
              width="225"
            >
              {{ '_helpTip' | translate: { _helpTip } }}
            </app-tooltip>
          </div>
          <div class="dashboard-title-buttons-container">
            <app-action-button
              (onClick)="redirect('/add-client')"
              *ngIf="_clientAddEnabled"
              color="primary"
              id="add-client-button"
              kind="outline"
              size="slightly-wider"
              >{{ 'Add New Client' | translate }}
            </app-action-button>
            <app-action-button
              (onClick)="redirect(_viewClientDestination)"
              color="primary"
              id="view-client-button"
              kind="filled"
              size="slightly-wider"
              >{{ _viewClientText | translate }}
            </app-action-button>
          </div>
        </div>
        <div>
          <app-table
            (onQuickViewButtonClick)="onQuickViewButtonClick($event)"
            [columnDefinitions]="_tableColumnDefinitions"
            [columnsToDisplay]="_tableColumnsToDisplay"
            [dataSource]="_tableData"
            [pageSize]="12"
            id="client-table"
            kind="standard"
            showPager="true"
          />
        </div>
      </div>
    </app-primary-card>
    <div class="dashboard-side-card-panel-container">
      <div class="dashboard-side-card-container">
        <app-client-information
          [attributes]="_clientInformationAttributes"
          [urlDisplayText]="_clientInformationDisplayText"
          [url]="_clientInformationUrl"
          id="client-information"
          subtitle="Quick View"
          title="Client Information"
        />
      </div>
    </div>
  </div>
</div>
